export function getBadgePresentation(src: string | null | undefined, failed: boolean, label: string, kind: "team" | "league" = "team") {
  return {
    showImage: Boolean(src && !failed),
    renderMode: "inline-svg" as const,
    initials: label.replace(/^الدوري |^دوري /, "").trim().slice(0, kind === "league" ? 3 : 2),
  };
}
